export const sendErrorEventToWindow = (action: string, label?: any) => {
    // gtag("event", action, {
    //   event_category: PLAT_FORM,
    //   event_label: label
    // });
    // console.log("sendEvent:\n", action, ":", label);
    try {
        if (typeof label === "object") {
            label = JSON.stringify(label);
        } else if (typeof label === "string") {
            label = label;
        } else {
            label = label.toString();
        }

        //rollbar打点
        (window as any).onerror("CustomError:" + label, window.location.href);
    } catch (error) {}
};
